import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet';
import { useLocation, useNavigate } from 'react-router-dom';
import Error from '../components/ui/Error';
import Loader from '../components/ui/Loader';
import Navbar from '../components/ui/Navbar';
import { useGetQuizzesQuery } from '../features/quizzes/quizzesApi';
import { useAddQuizzMarkMutation } from '../features/quizzMarks/quizzMarksApi';
import useAuth from '../hooks/useAuth';

function StudentQuizz() {
	//Variables
	const location = useLocation();
	const { id: video_id, title: video_title } = location.state || {};
	const { data: quizzes, isLoading, isError } = useGetQuizzesQuery();
	const [addQuizzMark] = useAddQuizzMarkMutation();
	const { name: student_name, id: student_id } = useAuth();
	const navigate = useNavigate();

	//States
	const [questions, setQuestions] = useState([]);
	const [initialValues, setInitialValues] = useState({});

	//Hooks
	useEffect(() => {
		if (quizzes?.length > 0 && video_id) {
			const filteredQuestions = quizzes.filter(quizz => quizz.video_id === Number(video_id));
			if (filteredQuestions?.length > 0) {
				setQuestions(filteredQuestions);
				const initialValues = filteredQuestions.reduce((acc, _, index) => {
					return Object.assign(acc, {
						[`option1_q${index + 1}`]: false,
						[`option2_q${index + 1}`]: false,
						[`option3_q${index + 1}`]: false,
						[`option4_q${index + 1}`]: false,
					});
				}, {});
				setInitialValues(initialValues);

			}
		}
	}, [video_id, quizzes])


	const { values, handleChange, handleSubmit } = useFormik({
		initialValues: initialValues,
		onSubmit: (values) => {
			const givenAnswer = Object.keys(values).reduce((acc, key) => {
				acc.push(key);
				return acc;
			}, []);
			const totalQuiz = questions.length;
			const totalCorrect = questions.reduce((count, question, index) => {
				const isCorrect = (
					question.options[0]['isCorrect'] === givenAnswer.includes(`option1_q${index + 1}`) &&
					question.options[1]['isCorrect'] === givenAnswer.includes(`option2_q${index + 1}`) &&
					question.options[2]['isCorrect'] === givenAnswer.includes(`option3_q${index + 1}`) &&
					question.options[3]['isCorrect'] === givenAnswer.includes(`option4_q${index + 1}`)
				);
				return count + (isCorrect ? 1 : 0);
			}, 0);
			const totalWrong = totalQuiz - totalCorrect;

			const payload = {
				student_id,
				student_name,
				video_id,
				video_title,
				totalQuiz,
				totalCorrect,
				totalWrong,
				totalMark: totalQuiz * 5,
				mark: totalCorrect * 5
			}
			addQuizzMark({ data: payload });
			navigate("/leaderboard");
		}

	});


	//Decide what to render
	let content = null;

	if (isLoading) {
		content = <Loader />
	}
	if (!isLoading && isError) {
		content = <Error message="There was an error occured!" />
	}
	if (!isLoading && !isError && questions.length === 0) {
		content = <div className='text-center'>No Questions Found!</div>
	}

	if (!isLoading && !isError && questions.length > 0) {
		content = (
			<section className="py-6 bg-primary">
				<div className="mx-auto max-w-7xl px-5 lg:px-0">
					<div className="mb-8">
						<h1 className="text-2xl font-bold">Quizzes for "{video_title}"
						</h1>
						<p className="text-sm text-slate-200">Each question contains 5 Mark</p>
					</div>
					<div className="space-y-8 ">

						<div className="quiz">
							<form className="quizOptions" onSubmit={handleSubmit}>
								{questions.map((question, index) => {
									const { id, question: questionTitle, options } = question || {};
									const [option1, option2, option3, option4] = options || [];
									const questionNumber = index + 1;
									return (
										<div className="question-container" key={id}>
											<h4 className="question">Quiz {questionNumber} - {questionTitle}</h4>
											<div className="options-container">
												<div className="option">
													<label htmlFor={`option1_q${questionNumber}`}>
														<input
															type="checkbox"
															id={`option1_q${questionNumber}`}
															name={`option1_q${questionNumber}`}
															defaultChecked={values[`option1_q${questionNumber}`]}
															onChange={handleChange}
														/>
														{option1?.option}
													</label>
													<label htmlFor={`option2_q${questionNumber}`}>
														<input
															type="checkbox"
															id={`option2_q${questionNumber}`}
															name={`option2_q${questionNumber}`}
															defaultChecked={values[`option2_q${questionNumber}`]}
															onChange={handleChange}
														/>
														{option2?.option}
													</label>
												</div>
												<div className="option">
													<label htmlFor={`option3_q${questionNumber}`}>
														<input
															type="checkbox"
															id={`option3_q${questionNumber}`}
															name={`option3_q${questionNumber}`}
															defaultChecked={values[`option3_q${questionNumber}`]}
															onChange={handleChange}
														/>
														{option3?.option}
													</label>
													<label htmlFor={`option4_q${questionNumber}`}>
														<input
															type="checkbox"
															id={`option4_q${questionNumber}`}
															name={`option4_q${questionNumber}`}
															defaultChecked={values[`option4_q${questionNumber}`]}
															onChange={handleChange}
														/>
														{option4?.option}
													</label>
												</div>
											</div>
										</div>
									);
								})}
								<button
									type='submit'
									className="px-4 py-2 rounded-full bg-cyan block ml-auto mt-8 hover:opacity-90 active:opacity-100 active:scale-95 ">Submit</button>
							</form>
						</div>
					</div>
				</div>
			</section>
		)
	}

	return (
		<>
			<Helmet>
				<title>Student Quiz</title>
			</Helmet>
			<Navbar />
			{content}
		</>
	)
}

export default StudentQuizz